import React from "react";
import { FaWhatsapp, FaFacebookF, FaInstagram } from "react-icons/fa";
import "./SocialIcons.css";

const SocialIcons = () => {
  return (
    <div className="social-icons">
      <a
        href="https://wa.me/8009539867"
        target="_blank"
        rel="noopener noreferrer"
        className="icon whatsapp"
      >
        <FaWhatsapp />
      </a>

      <a
        href="https://www.facebook.com/profile.php?id=100095550450730&mibextid=wwXIfr&rdid=shG86gF7uwG7JU26&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F17hM7PEWbu%2F%3Fmibextid%3DwwXIfr#"
        target="_blank"
        rel="noopener noreferrer"
        className="icon facebook"
      >
        <FaFacebookF />
      </a>

      <a
        href="https://www.instagram.com/ujala_e_mobility_pvt_ltd_?igsh=MWt5bGd4cm16aHV3Zw%3D%3D&utm_source=qr"
        target="_blank"
        rel="noopener noreferrer"
        className="icon instagram"
      >
        <FaInstagram />
      </a>

      {/* OFFER BADGE */}
      <div className="price-offer">
        <span>Starting Price</span>
        <strong>₹ 39,999</strong>
      </div>
    </div>
  );
};

export default SocialIcons;
